// Styles for ChangePassword go here.
import styled, { createGlobalStyle } from 'styled-components';

export const StyledChangePassword = styled.div``;

export const FlyOutModalStyle = createGlobalStyle`
  .container-modal-v2 {
    padding: 0 !important;
  }
  .account-flyout-wrapper {
    padding: 0 !important;
    margin-top: 0 !important;
  }
`;
